import React, { useEffect, useRef } from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'

import './TranspaisScreenSaver.scss'
import { recordFlightEvent } from '../../debug/flightRecorder'

/**
 * onInteract: cierre explícito (no depender solo de react-idle-timer: si el timer está pausado,
 * el hook quita los listeners del documento y el salvapantallas no se puede quitar).
 *
 * Se escucha actividad en window (mousemove, pointermove, etc.) como antes con el timer en document,
 * para que bastante con mover el ratón sin hacer clic.
 */
const TranspaisScreenSaver = ({ show, onInteract }) => {
    const dismissedRef = useRef(false)

    useEffect(() => {
      if (!show) {
        dismissedRef.current = false
      }
    }, [show])

    useEffect(() => {
      if (!show || typeof onInteract !== 'function') return

      dismissedRef.current = false
      recordFlightEvent('SAVER:OVERLAY_MOUNT', {}, 'TranspaisScreenSaver.effect')

      const tryDismiss = () => {
        if (dismissedRef.current) return
        dismissedRef.current = true
        recordFlightEvent('SAVER:OVERLAY_DISMISS_CALL', {}, 'TranspaisScreenSaver.tryDismiss')
        onInteract()
      }

      /* Misma idea que DEFAULT_EVENTS de react-idle-timer: cualquier señal de actividad cierra. */
      const activityOpts = { capture: true, passive: true }
      const onActivity = (e) => {
        recordFlightEvent('SAVER:OVERLAY_ACTIVITY', { type: e?.type || null }, 'TranspaisScreenSaver.onActivity')
        tryDismiss()
      }

      window.addEventListener('pointermove', onActivity, activityOpts)
      window.addEventListener('mousemove', onActivity, activityOpts)
      window.addEventListener('pointerdown', onActivity, activityOpts)
      window.addEventListener('touchstart', onActivity, activityOpts)
      window.addEventListener('wheel', onActivity, activityOpts)
      window.addEventListener('keydown', onActivity, activityOpts)

      return () => {
        recordFlightEvent('SAVER:OVERLAY_UNMOUNT', {}, 'TranspaisScreenSaver.cleanup')
        window.removeEventListener('pointermove', onActivity, activityOpts)
        window.removeEventListener('mousemove', onActivity, activityOpts)
        window.removeEventListener('pointerdown', onActivity, activityOpts)
        window.removeEventListener('touchstart', onActivity, activityOpts)
        window.removeEventListener('wheel', onActivity, activityOpts)
        window.removeEventListener('keydown', onActivity, activityOpts)
      }
    }, [show, onInteract])

    /*useEffect(() => {
      if (show) {
          const el = document.getElementById('backgroundvid')
          loggerDebug('play', el)
          if (el) {
              el.play()
          }
      } else {
          const el = document.getElementById('backgroundvid')
          loggerDebug('pause', el)
          if (el) {
              el.pause()
          }
      }
    }, [show])*/

    const handleDismiss = (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (dismissedRef.current) return
      dismissedRef.current = true
      if (typeof onInteract === 'function') {
        onInteract()
      }
    }

    return (
        <TransitionGroup>
            {show && (
                <CSSTransition classNames="loader" timeout={300}>
                    <div
                      className={['screen-saver', show ? 'screen-saver-show' : null].join(' ')}
                      role="button"
                      tabIndex={0}
                      aria-label="Toca la pantalla para continuar"
                      onPointerDown={handleDismiss}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault()
                          handleDismiss(e)
                        }
                      }}
                    >
                        <video id="backgroundvid" playsInline autoPlay loop={true} muted>
                            <source src="https://transpais-kiosk.s3.amazonaws.com/screensaver/cami_2.mp4" type="video/mp4"/>
                            <p>Fallback content to cover incompatibility issues</p>
                        </video>
                    </div>
                </CSSTransition>
            )}
        </TransitionGroup>)
}

export default TranspaisScreenSaver
